import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import { Form, Input, Switch } from "antd";
import { useFormService, useI18n } from "../../../../../contexts";
import { FormValueDifferFromTemplateTag } from "../../..";
import { Notices } from "../../../../common";
const FormServiceFieldGeneralProvider = ()=>{
    const { __, _i } = useI18n();
    const { template } = useFormService();
    const [ref, setRef] = useState();
    const isProviderCurrentWebsiteLabel = __("I as the website operator am the provider/responsible for data processing (usually for self-hosted services)");
    return /*#__PURE__*/ _jsx(Form.Item, {
        label: __("Provider"),
        required: true,
        children: /*#__PURE__*/ _jsx(Form.Item, {
            noStyle: true,
            shouldUpdate: (prevValues, nextValues)=>prevValues.isProviderCurrentWebsite !== nextValues.isProviderCurrentWebsite,
            children: (param)=>{
                let { getFieldValue, setFieldValue } = param;
                const isProviderCurrentWebsite = getFieldValue("isProviderCurrentWebsite");
                return /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            style: {
                                marginTop: 4
                            },
                            children: [
                                /*#__PURE__*/ _jsx(Form.Item, {
                                    name: "isProviderCurrentWebsite",
                                    valuePropName: "checked",
                                    noStyle: true,
                                    children: /*#__PURE__*/ _jsx(Switch, {})
                                }),
                                /*#__PURE__*/ _jsxs("span", {
                                    children: [
                                        "\xa0\xa0",
                                        isProviderCurrentWebsiteLabel
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            style: {
                                marginTop: 10,
                                marginBottom: isProviderCurrentWebsite ? 0 : 10
                            },
                            ref: setRef,
                            children: /*#__PURE__*/ _jsx(FormValueDifferFromTemplateTag, {
                                form: "service",
                                valueName: "isProviderCurrentWebsite",
                                widthOfRef: ref,
                                renderDiff: (value)=>/*#__PURE__*/ _jsxs(_Fragment, {
                                        children: [
                                            /*#__PURE__*/ _jsx(Switch, {
                                                disabled: true,
                                                checked: value
                                            }),
                                            /*#__PURE__*/ _jsxs("span", {
                                                children: [
                                                    "\xa0\xa0",
                                                    isProviderCurrentWebsiteLabel
                                                ]
                                            })
                                        ]
                                    }),
                                noBr: true
                            })
                        }),
                        /*#__PURE__*/ _jsx(Form.Item, {
                            name: "provider",
                            noStyle: true,
                            rules: [
                                {
                                    required: !isProviderCurrentWebsite,
                                    message: __("Please name a provider!")
                                }
                            ],
                            dependencies: [
                                "isProviderCurrentWebsite"
                            ],
                            children: /*#__PURE__*/ _jsx(Input.TextArea, {
                                autoSize: true,
                                style: {
                                    display: isProviderCurrentWebsite ? "none" : undefined
                                },
                                placeholder: __("e.g. Global Co., 90210 Broadway Blvd., Nashville, TN 37011-5678"),
                                onKeyPress: (e)=>{
                                    // Do not allow paragraphs
                                    if (e.keyCode === 13 || e.which === 13) {
                                        e.preventDefault();
                                        return false;
                                    }
                                    return undefined;
                                },
                                onPaste: (e)=>{
                                    // Remove paragraphs when pasted through clipboard
                                    setTimeout(()=>{
                                        const { value } = e.target;
                                        setFieldValue("provider", value.replace(/\n+/gm, ", "));
                                    }, 0);
                                }
                            })
                        }),
                        /*#__PURE__*/ _jsxs("p", {
                            className: "description",
                            ref: setRef,
                            children: [
                                !isProviderCurrentWebsite && /*#__PURE__*/ _jsx(FormValueDifferFromTemplateTag, {
                                    form: "service",
                                    valueName: "provider",
                                    widthOfRef: ref,
                                    renderDiff: (value)=>/*#__PURE__*/ _jsx(Input, {
                                            value: value,
                                            readOnly: true
                                        })
                                }),
                                _i(__('Services have an "owner" who processes personal data or information saved in cookies etc. For self-hosted services, you are the data processor. Your contact details under {{a}}Settings > General > Website operator details{{/a}} are used. For other services, input the provider\'s contact details, often found in their privacy policy.'), {
                                    a: /*#__PURE__*/ _jsx("a", {
                                        href: "#/settings",
                                        target: "_blank",
                                        style: {
                                            fontStyle: "italic"
                                        }
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Notices, {
                            notices: [
                                {
                                    message: template == null ? void 0 : template.providerNotice,
                                    severity: "info"
                                }
                            ]
                        })
                    ]
                });
            }
        })
    });
};
export { FormServiceFieldGeneralProvider };
